import NewBudgetItem from "../Common/NewBudgetItem";

export default function NewSaving() {
  return <NewBudgetItem itemType="savings" />;
}
